import type { GameLobbyPayload } from "models/GameLobbyPayload";
import { Map } from "utils/constants";

export type GameLobbyType = {
  creator: {
    UserId: string;
    name: string;
  };
  _id: string;
  name: string;
  boardName: Map;
  preludeActive: boolean;
  venusActive: boolean;
  solarActive: boolean;
  coloniesActive: boolean;
  allowReplayMode: boolean;
  players: PlayerType[];
  isPasswordProtected: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export type PlayerType = {
  _id: string;
  UserId: string;
  name: string;
};

export const buildGameLoggyTypeFromGameLobbyPayload = (
  payload: GameLobbyPayload,
): GameLobbyType => ({
  ...payload,
});
